import clsx from 'clsx';
import type { Ref } from 'react';
import React, { forwardRef } from 'react';

interface ISelectField extends React.HTMLProps<HTMLSelectElement> {
  id: string;
  hideLabel?: boolean;
  label?: string;
  options: {
    value: string;
    label: string;
  }[];
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
}

const SelectField = forwardRef(
  (
    {
      id,
      label,
      hideLabel,
      options,
      onChange,
      required,
      className,
      ...rest
    }: ISelectField,
    ref: Ref<HTMLSelectElement>
  ) => {
    return (
      <div className={clsx(className)}>
        <label
          className={clsx(
            'mb-2 block text-sm font-bold text-gray-700',
            hideLabel && 'sr-only'
          )}
          htmlFor={id}
        >
          {label}
        </label>
        <select
          id={id}
          className="w-full border-b border-grayAlt-500 bg-transparent py-2 text-cream outline-0"
          onChange={onChange}
          required={required}
          ref={ref}
          {...rest}
        >
          {options.map((option, i) => (
            <option
              className="text-black"
              selected={i === 0}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
);

SelectField.displayName = 'SelectField';

export default SelectField;
